import type { InjectionKey } from 'vue'

export type TrackEventFn = (name: string, params?: Record<string, unknown>) => void

export const trackEventKey: InjectionKey<TrackEventFn> = Symbol('trackEvent')
export const marathonNameKey: InjectionKey<string> = Symbol('marathonName')

export function useAnalytics() {
  const trackEvent: TrackEventFn = (name, params) => {
    if (typeof window.gtag !== 'function') return
    window.gtag('event', name, params)
  }

  return { trackEvent }
}
